import useSWR from "swr";
import { API_GET_MINTED_NFT_LIST, getProticoClient } from "../utils/api";
import { useWeb3Auth } from "./useWeb3Auth";
export type IPassClassMeta = {
  title: string;
  name_base: string;
  field_a_header: string;
  field_a_value: string;
  field_b_header: string;
  field_b_value: string;
  barcode_value: string;
  background_color: string;
  label_color: string;
};
export type NFTInfo = {
  name: string;
  symbol: string;
};

export interface MintedNFT {
  id: number;
  token_id: string;
  domain: string;
  protico_user_address: string;
  created_at: string;
  domain_nft_info: NFTInfo;
  domain_nft_logo: string;
  passclass_meta: IPassClassMeta;
  contract_address: string;
}

const fetcher = async () => {
  try {
    const response = await getProticoClient().api.get(API_GET_MINTED_NFT_LIST);
    return response.data as Array<MintedNFT>;
  } catch (err) {
    console.error("Failed to fetch minted NFT list", err);
    return [];
  }
};
const useMintedNftList = () => {
  const { address, isProticoAuthenticated } = useWeb3Auth();

  const { data, error } = useSWR(
    isProticoAuthenticated ? [`useMintedNftList-${address}`] : null,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: false,
    }
  );

  return {
    mintedNftList: data ?? [],
    isLoading: !error && !data,
    isError: error,
  };
};

export default useMintedNftList;
